import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../api.service";
import {KeyValuePipe} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatIcon} from "@angular/material/icon";
import {MatDialog, MatDialogActions, MatDialogClose, MatDialogContent} from "@angular/material/dialog";

@Component({
  selector: 'anon-dialog',
  template: `
    <mat-dialog-content>
      <h2>Upozornění</h2>
      <p>Odstraněním dat dojde k anonymizaci tohoto profilu.</p>
      <p>Po anonymizaci bude uživatel odhlášen a už se do aplikace nebude moci vrátit.</p>
      <p>Opravdu si přejete anonymizovat tento účet?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button [mat-dialog-close]="onNoClick()">Ne</button>
      <button mat-button [mat-dialog-close]="anonymizeConfirm()">Ano</button>
    </mat-dialog-actions>`,
  imports: [MatButton, MatDialogActions, MatDialogClose, MatDialogContent]
})
export class AnonDialog {
  onNoClick() {
    return false;
  }
  anonymizeConfirm() {
    return true;
  }
}

@Component({
  selector: 'app-user',
  imports: [
    KeyValuePipe,
    MatButton,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MatIcon
  ],
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent implements OnInit {
  public data: any = {
    activities: [],
    respondentData: []
  };
  private uid:any;

  constructor(private route: ActivatedRoute, private api: ApiService, private router: Router, private dialog: MatDialog) {
  }

  async ngOnInit() {
    this.uid = this.route.snapshot.paramMap.get('id');
    this.data = await this.api.getResponendt(this.uid);
  }

  goToDashboard() {
    this.router.navigate(['admin/users']);
  }

  async quickAnonymize() {
    const ref = this.dialog.open(AnonDialog);
    ref.afterClosed().subscribe(result => {
      if (result) {
        this.api.quickAnonymize(this.uid).then(() => {
          this.goToDashboard();
        });
      }
    });
  }
}
